import { FormattedMessage } from "react-intl";
import type { PixiPaymentMethod } from "../../hooks/usePixiWizardState";
import creditCardIcon from "./assets/credit-card.svg";
import directDebitIcon from "./assets/direct-debit.svg";
import invoiceIcon from "./assets/invoice.svg";
import paypalIcon from "./assets/paypal.svg";
import { MethodCard, MethodGrid, MethodIcon, MethodLabel } from "./styles";

interface MethodConfig {
  method: PixiPaymentMethod;
  icon: string;
  labelId: string;
  defaultLabel: string;
  /** All methods selectable; step 4 (Checkout) performs each method's gateway op. */
  selectable: boolean;
}

const METHODS: MethodConfig[] = [
  {
    method: "credit_card",
    icon: creditCardIcon,
    labelId: "pixi_wizard.payment_shipping.method.credit_card",
    defaultLabel: "Credit card",
    selectable: true,
  },
  {
    method: "paypal",
    icon: paypalIcon,
    labelId: "pixi_wizard.payment_shipping.method.paypal",
    defaultLabel: "PayPal",
    selectable: true,
  },
  {
    method: "direct_debit",
    icon: directDebitIcon,
    labelId: "pixi_wizard.payment_shipping.method.direct_debit",
    defaultLabel: "Direct Debit",
    selectable: true,
  },
  {
    method: "invoice",
    icon: invoiceIcon,
    labelId: "pixi_wizard.payment_shipping.method.invoice",
    defaultLabel: "Invoice",
    selectable: true,
  },
];

interface PaymentMethodPickerProps {
  selected: PixiPaymentMethod;
  onSelect: (method: PixiPaymentMethod) => void;
}

export const PaymentMethodPicker = ({
  selected,
  onSelect,
}: PaymentMethodPickerProps) => (
  <MethodGrid data-testid="payment-method-picker" role="radiogroup">
    {METHODS.map(({ method, icon, labelId, defaultLabel, selectable }) => {
      const isActive = method === selected;
      return (
        <MethodCard
          key={method}
          type="button"
          $active={isActive}
          role="radio"
          aria-checked={isActive}
          aria-disabled={!selectable}
          disabled={!selectable}
          onClick={() => selectable && onSelect(method)}
          data-testid={`payment-method-${method}`}
        >
          <MethodIcon src={icon} alt="" aria-hidden="true" />
          <MethodLabel $active={isActive}>
            <FormattedMessage id={labelId} defaultMessage={defaultLabel} />
          </MethodLabel>
        </MethodCard>
      );
    })}
  </MethodGrid>
);
